import React from 'react';
import SelectPollingDateRange from '../../SelectPollingDateRange/SelectPollingDateRange';
import './DateTimeRangePickerField.scss';

const DateTimeRangePickerField = (properties) => {
  const {
    schema: { title, panelId, pickerId },
    onChange,
    required,
  } = properties;

  return (
    <div className={`date-time-picker`}>
      <label>{`${title}${required ? '*' : ''}`}</label>
      <SelectPollingDateRange
        panelId={panelId}
        pickerId={pickerId}
        enableGlobalDates={false}
        onRangeCommit={(selectedDateRange) =>
          onChange({
            from: selectedDateRange.startDate,
            to: selectedDateRange.endDate,
          })
        }
      />
    </div>
  );
};

export default DateTimeRangePickerField;
